import { version } from '../../../../package.json';
import { Config as LoggerConfig, Logger, HavenLogger } from '@hit/logger';
import Config from '@hit/config';
import { CPLogger } from './CPLogger';
import { serverOnly } from '../helpers';

export { Category, PiiLevelEnum } from '@hit/logger';

export class LoggerSingleton extends CPLogger {
  static _instance: HavenLogger;
  static _app: string;

  private constructor() {
    super();
  }

  @serverOnly()
  static getInstance(defaultEnv: string = 'development'): HavenLogger {
    if (!LoggerSingleton._instance) {
      const rootConfig = Config.getConfig({
        configParams: [{ sourceName: 'root', appRootPath: __dirname, subPath: '../../../..' }],
      });
      const logLevel = rootConfig.get('logConfig:level') ?? 'info';
      const loggerConfig: LoggerConfig = {
        level: logLevel,
        appVersion: version,
        environment: process.env.APP_ENV ?? process.env.NODE_ENV ?? defaultEnv,
        app: process.env.APPLICATION ?? 'coverpath',
        obfuscationOptOut: this.getObfuscationKeys(rootConfig),
      };

      const logger = new Logger(loggerConfig).getSystemLogger();
      this._app = loggerConfig.app;
      const childLogger = logger.childLogger({
        error: {
          isHumanRelated: false,
        },
      });
      childLogger.level(logLevel);
      LoggerSingleton._instance = childLogger;
    }
    return LoggerSingleton._instance;
  }

  private static getObfuscationKeys(config: Config): { [key: string]: boolean } {
    const optOutStringKeys = config.get('logObfuscationOptOutKeys');
    const optInStringKeys = config.get('logObfuscationOptInKeys');

    const optOutKeys =
      typeof optOutStringKeys === 'string' &&
      optOutStringKeys.split(',').reduce((accumulator, value) => {
        const key = value.trim();
        if (key) {
          accumulator[key] = true;
        }
        return accumulator;
      }, {});

    const optInKeys =
      typeof optInStringKeys === 'string' &&
      optInStringKeys.split(',').reduce((accumulator, value) => {
        const key = value.trim();
        if (key) {
          accumulator[key] = false;
        }
        return accumulator;
      }, {});

    // For security reasons if there is a key collision the opt-in key would win.
    return {
      ...optOutKeys,
      ...optInKeys,
    };
  }

  static setInstance(instance: HavenLogger) {
    if (!this._instance) {
      this._instance = instance;
    }
  }
}
